// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  BooleanField,
  BooleanInput,
  useListContext,
  FilterButton,
  TopToolbar,

} from "react-admin";
import { JsonField, JsonInput } from "react-admin-json-view";
// import { Link } from "react-router-dom";
import { useRecordContext } from 'react-admin';


const MyUrlField = ({ source }) => {
  const record = useRecordContext();
  const value = record && record[source];


  if (value == null) {
    return null;
  }
  else {
    let lat = null;
    let lng = null;
    if (value.coordinates) {
      if (value.coordinates.length > 0) {
        lat = value.coordinates[1]
        lng = value.coordinates[0]
      }
    }

    return (
      <a target="__blank" href={`http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify(record.geometry))}`}>
        {`Voir le quartier`}
      </a>
    );
  }
}
MyUrlField.defaultProps = {
  addLabel: true,
};
const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[100, 300, 500]} {...props} />
);

const QuartiersFilter = (props) => (
  <Filter {...props}>
    <TextInput label="id" source="id" alwaysOn />
    <TextInput label="Type" source="type" alwaysOn />
    <TextInput label="Quartier" source="quartier" alwaysOn />
    <TextInput label="Region" source="region" alwaysOn />
    <TextInput label="Province" source="province" alwaysOn />
    <TextInput label="Commune" source="commune" alwaysOn />
    <BooleanInput label="Display" source="display" />
  </Filter>
);
const Aside = () => {
  const { data, isLoading, selectedIds } = useListContext();
  if (isLoading) return null;
  console.log({
    "type": "FeatureCollection",
    "features": Object.keys(data).map(key => {
      return ({ ...data[key], properties: {} })
    }).filter(item => {
      return (selectedIds.includes(item.id))
    })
  })
  console.log(selectedIds)
  return (
    <TopToolbar>

      <a target="__blank" href={`http://geojson.io/#data=data:application/json,${encodeURIComponent(JSON.stringify({
        "type": "FeatureCollection",
        "features": Object.keys(data).map(key => {

          return ({
            ...data[key], properties: {
              _id: data[key].id,
              province: data[key].province,
              commune: data[key].commune,
              quartier: data[key].quartier,
            }
          })

        }).filter(item => {
          return (selectedIds.includes(item.id))
        })
      }))}`}>
        {`Voir les quartiers sélectionnés`}
      </a>

    </TopToolbar>
  );
};
const PostBulkActionButtons = () => (
  <>
    <div></div>
  </>
);

export const QuartiersList = (props) => (
  <List
    {...props}
    bulkActionButtons={<PostBulkActionButtons />}
    aside={<Aside />}
    filters={<QuartiersFilter />}
    pagination={<PostPagination />}
  >
    <Datagrid bulkActionButtons={<PostBulkActionButtons />}>
      <TextField source="id" />
      <TextField source="type" />
      <TextField source="quartier" />
      <TextField source="region" />
      <TextField source="province" />
      <TextField source="commune" />
      <BooleanField source="display" />
      <MyUrlField source="geometry" label="Découpage" />
      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const QuartiersShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <MyUrlField source="geometry" label="Découpage" />


      <TextField source="type" />
      <TextField source="quartier" />
      <TextField source="region" />
      <TextField source="province" />
      <TextField source="commune" />
      <BooleanField source="display" />
      <JsonField source="properties" />
    </SimpleShowLayout>
  </Show>
);

export const QuartiersEdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar />}>
      <TextInput source="id" />
      <TextInput source="type" />
      <TextInput source="quartier" />
      <TextInput source="region" />
      <TextInput source="province" />
      <TextInput source="commune" />
      <BooleanInput source="display" />
      <JsonInput source="properties" />
    </SimpleForm>
  </Edit>
);
